
/**
 * Creat THREE.JS fundamental element (eg Renderer, Scene, Camera, Lights)
 * */

import * as THREE from '../libs/three/three.module.js'
import physic from './createPhysic.js'
import { OrbitControls } from '../libs/jsm/controls/OrbitControls.js'
import main from "../pages/pileGame/main"
export default {
  loopFunc: [],

  /**
   * @param {Object} option = {
   *                     usePhysic: bool
   *                 }
   * */
  init(option = {}) {
    this.time = 0
    this.clock = new THREE.Clock()
    this.clearVueThreeTrash()

    return new Promise( (resolve, reject) => {
      if(option.usePhysic){
        this.initPhysicThree(resolve)
      }else{
        this.initThree()
        resolve()
      }
    } )

  },
  initPhysicThree(callback){
    try{
      if(Ammo && Ammo.Config){
        this.initThree()
        callback()
        return
      }
    }catch (e) {}
    this.addJs('assets/three/libs/ammo/ammo.js')
      .then(() => {
        Ammo().then( AmmoLib => {
          Ammo = AmmoLib
          this.physic = physic.initPhysic()
          this.initThree()
          callback()
        })
      })
      .catch( e => {
        console.log('加载出错: ', e)
      })

  },
  initThree(){
    this.createRenderer()
    this.createScene()
    this.createCamera()
    this.createLights()

    this.animate()

    this.onWindowResize()
  },
/**
 *
 * @param {String} canvasId - The Id of div for canves
 */
  createRenderer(canvasId = 'three') {
    this.container = document.getElementById(canvasId)

    this.renderer = new THREE.WebGLRenderer({antialias: true})
    this.renderer.setPixelRatio(window.devicePixelRatio)
    this.renderer.setSize(window.innerWidth, window.innerHeight)
    this.renderer.setClearColor(0xcecece)
    this.renderer.shadowMap.enabled = true
    this.container.appendChild(this.renderer.domElement)
  },
  createScene() {
    this.scene = new THREE.Scene()
    this.scene.background = new THREE.Color(0xbfd1e5)

    this.scene.fog = new THREE.Fog(0xffffff, 0.015, 210)
  },
  createCamera() {
    this.camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 1, 1000)
    this.camera.position.set(55, 40, 55)
    this.camera.lookAt(new THREE.Vector3(8, 0, 8))
    this.scene.add(this.camera)
  },
  createLights() {
    this.light = new THREE.SpotLight(0xFFFFFF)
    this.light.position.set(20, 100, 50)
    this.light.shadow.mapSize.width = 2048
    this.light.shadow.mapSize.height = 2048
    this.scene.add(this.light)
  },


  createOrbitControl() {
    this.orbitControl = new OrbitControls( this.camera, this.renderer.domElement )
    this.orbitControl.screenSpacePanning = true
    this.orbitControl.minDistance = 5
    this.orbitControl.maxDistance = 40
    this.orbitControl.target.set( 0, 2, 0 )
    this.orbitControl.update()
    return this.orbitControl
  },


  render(){
    let deltaTime = this.clock.getDelta()

    this.physic && physic.updatePhysics( deltaTime )

    this.loopFunc.forEach( func => {
      func(deltaTime)
    } )

    this.renderer.render( this.scene, this.camera )

    this.time += deltaTime
  },
  animate(){
    this.animationId = requestAnimationFrame( () => { this.animate() } )
    this.render()
  },


  onWindowResize() {

    let resize = () => {
      this.camera.aspect = window.innerWidth / window.innerHeight
      this.camera.updateProjectionMatrix()
      this.renderer.setSize( window.innerWidth, window.innerHeight )
    }

    window.addEventListener('resize', resize, false)

  },

  addJs(url){

    return new Promise( resolve => {
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = url
      document.getElementsByTagName('head')[0].appendChild(script)
      script.onload = () => { resolve() }
    })

  },

  // Vue会把里面的内容当作自己的this对待，之前的数据和方法会一直存在
  clearVueThreeTrash(){
    this.loopFunc = []
    if(this.animationId !== undefined){
      cancelAnimationFrame(this.animationId)
      this.animationId = undefined
    }
  }
}
